import { ChevronRight } from 'lucide-react'
import { MouseEventHandler, forwardRef } from 'react'

export const RotatingExpanderButton = forwardRef<
  HTMLDivElement,
  {
    hidden?: boolean
    expanded: boolean
    expandable?: boolean
    onClick: MouseEventHandler<HTMLDivElement>
  }
>(({ expanded, expandable, onClick }, ref) => {
  return (
    <div
      ref={ref}
      className={`hidden h-8 w-5 cursor-pointer items-center justify-center transition duration-200 max-sm:flex sm:group-hover/link:flex ${expandable ? 'max-sm:opacity-100 sm:opacity-0 sm:group-hover:opacity-100' : 'opacity-0'} ${expanded ? 'rotate-90' : 'rotate-0'} text-doss-border max-sm:text-doss-slate sm:group-hover/link:text-doss-slate`}
      onClick={onClick}
    >
      <ChevronRight size={14} />
    </div>
  )
})

RotatingExpanderButton.displayName = 'RotatingExpanderButton'
